
import kebabCase from 'lodash.kebabcase';
import type { ClickOrPressEvent } from 'types/mouseEvents';

// *****To update this file see `tools/generate-icon-imports.mjs`*****

import { ReactComponent as Map } from 'assets/icons-duotone/map.svg?react';

export type IconString =

| 'map';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
export const allIconComponents: Record<IconString, IconSVG> = { map: Map };

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon: IconString | string;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Icon: React.FC<IconProps> = props => {
    const { icon, className, onClick } = props;
    const iconName = kebabCase(icon) as IconString;
    const SpecificIcon = allIconComponents[iconName];

    if (!SpecificIcon) {
        return null;
    }

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    const iconClass = `svg-icon ${isClickableClass} ${className ? className : ''}`;

    return <SpecificIcon onClick={onClick} className={iconClass} />;
};

export default Icon;
